import App from "../../../../app/App";

const DssSavers = {

    sumWarnings: {
        warning01: [],
        warning02: [],
        warning03: [],
        warning04: []
    },

    init() {

        this.el = $('[component="DssSavers"]');

        if (!this.el.length) {
            return;
        }

        this.labels = this.el.find('section .leftLabels');
        this.inputs = this.el.find('[component="Input"] input');
        this.submitButton = $('.formSubmit');
        this.button = {
            ajax: $('.ajax')
        }

        this.inputPISNEPIS = this.el.find('input[name="pis"], input[name="nepis"], input[name="value10"]');
        this.inputSaversNumbers = this.el.find('input[name="value02"], input[name="value03"], input[name="value01"]');
        this.inputAllContracts = this.el.find('input[name="value05"], input[name="value06"], input[name="value07"], input[name="value04"]');

        this.badValuesAlertButton = $(".badValuesAlert").find("button");

        this.start();
        this.bind();
    },

    start() {
    },

    bind() {

        if (App.project === "adss") {
            this.inputPISNEPIS.on('change', function (element) {
                let section = $(this).closest('section[component="FundBox"]');

                DssSavers.checkPISNEPISInputSum(section);
            });

            this.inputSaversNumbers.on('change', function (element) {
                let section = $(this).closest('section[component="FundBox"]');

                DssSavers.checkSaversNumbersInputSum(section);
                DssSavers.checkCompareWithPreviousMonthSaversNumber(section);
            });

            this.inputAllContracts.on('change', function (element) {
                let section = $(this).closest('section[component="FundBox"]');

                DssSavers.checkAllContracts(section);
            });


            setTimeout(() => {
                let sections = $('[component="DayBox"]:not(.asHeader) section[component="FundBox"]');

                $.each(sections, (index, section) => {
                    DssSavers.checkPISNEPISInputSum($(section));
                    DssSavers.checkSaversNumbersInputSum($(section));
                    DssSavers.checkCompareWithPreviousMonthSaversNumber($(section));
                    DssSavers.checkAllContracts($(section));
                });
            }, 2000);
        }


        this.inputs.focus((element) => {
            let getInput = $(element.currentTarget);
            let activeLabel = this.labels.find('.label[input="' + getInput.attr("name") + '"]');

            if (!activeLabel.length) {
                return;
            }

            DssSavers.setLabel(activeLabel);
        });

        this.inputs.focusout(() => {
            DssSavers.resetLabelFocus();
        });

        this.labels.find('.label').on('click', function (element) {

            let getInput = $(this).attr("input");
            let input = DssSavers.el.find('[name="' + getInput + '"]').first();

            if (!input.length) {
                return;
            }

            input.focus();
        });

        this.button.ajax.on("click", async (element) => {

            clearTimeout(App.ajaxSendProtection);

            App.ajaxSendProtection = setTimeout(() => {

                let button = $(element.currentTarget).data();
                let cronJob = App.getCronJobLink(button.job);

                if (!cronJob) {
                    console.error("Missing cron link");
                    return false;
                }

                App.showLoading();
                App.ajax(
                    button.library,
                    button.event,
                    {
                        link: CRON_ADRESS_SECURED,
                        request: cronJob
                    },
                    (response) => {
                        // this.hotlinks.addClass("reportFound");
                        // this.hotlinks.parents('[component="Alert"]').addClass("reportFound");
                        //
                        // $('.storageLink').prop("href", response.storage_link);
                    }
                )
            }, 500);

            return false;
        });

        this.badValuesAlertButton.on("click", () => {
            $(".badValuesAlert").removeClass("visible");
            $('[component="DragAndDrop"]').addClass("hidden");
        });
    },

    resetLabelFocus() {
        this.labels.find(".active").removeClass("active");
    },

    setLabel(label) {
        $(label).addClass("active");
    },

    checkPISNEPISInputSum(section, popup = true) {
        let sum = 0;
        let inputs = section.find('input[name="pis"], input[name="nepis"], input[name="value10"]');

        section.find('input[name="pis"], input[name="nepis"]').each(function () {
            let input = $(this);
            let value = DssSavers.sanitizedValue(input.val());

            if (!isNaN(value)) {
                sum += value;
            }
        });

        let value10 = section.find('input[name="value10"]');
        let equal = DssSavers.sanitizedValue(value10.val());
        let fund = section.data("fund");
        const isInvalid = sum !== equal && equal;

        if (isInvalid || sum === 0) {
            DssSavers.sumWarnings.warning01[fund] = {
                value1: section.find('input[name="pis"]').val(),
                value2: section.find('input[name="nepis"]').val(),
                sum: section.find('input[name="value10"]').val(),
                company: fund
            };
        } else {
            delete DssSavers.sumWarnings.warning01[fund];
        }

        this.badValuesAlert(section, popup);

        if (isInvalid || sum === 0) {
            inputs.closest('[component="Input"]').addClass("bad");
        } else {
            inputs.closest('[component="Input"]').removeClass("bad");
        }
    },

    checkSaversNumbersInputSum(section, popup = true) {
        let sum = 0;
        let inputs = section.find('input[name="value02"], input[name="value03"], input[name="value01"]');

        section.find('input[name="value02"], input[name="value03"]').each(function () {
            let input = $(this);
            let value = DssSavers.sanitizedValue(input.val());

            if (!isNaN(value)) {
                sum += value;
            }
        });

        let value01 = section.find('input[name="value01"]');
        let equal = DssSavers.sanitizedValue(value01.val());
        let fund = section.data("fund");
        const isInvalid = sum !== equal && equal;

        if (isInvalid || sum === 0) {
            DssSavers.sumWarnings.warning02[fund] = {
                value1: section.find('input[name="value02').val(),
                value2: section.find('input[name="value03"]').val(),
                sum: section.find('input[name="value01"]').val(),
                company: fund
            };
        } else {
            delete DssSavers.sumWarnings.warning02[fund];
        }

        this.badValuesAlert(section, popup);

        if (isInvalid || sum === 0) {
            inputs.closest('[component="Input"]').addClass("bad");
        } else {
            inputs.closest('[component="Input"]').removeClass("bad");
        }
    },

    checkCompareWithPreviousMonthSaversNumber(section, popup = true) {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1; // Adding 1 to get a 1-indexed month
        const currentYear = currentDate.getFullYear();
        let tolerance = 200;

        if (currentMonth === 5 && currentYear === 2024) {
            return;
        }

        if (typeof SAVERS_HISTORY === 'undefined') {
            return;
        }

        let input = section.find('input[name="value01"]');
        let dss = section.data("dss");

        let valueNow = DssSavers.sanitizedValue(input.val());
        let valuePrevious = SAVERS_HISTORY.hasOwnProperty(dss) && SAVERS_HISTORY[dss].hasOwnProperty('value10') ? SAVERS_HISTORY[dss]['value10'] : 0;
        let fund = section.data("fund");

        if (Math.abs(valueNow - valuePrevious) < tolerance && (valueNow && valuePrevious)) {
            input.closest('[component="Input"]').addClass("alert");
        }

        if (Math.abs(valueNow - valuePrevious) > tolerance && (valueNow && valuePrevious)) {
            DssSavers.sumWarnings.warning04[fund] = {
                value1: valuePrevious,
                value2: valueNow,
                difference: Math.abs(valueNow - valuePrevious),
                company: fund
            };

            input.closest('[component="Input"]').addClass("bad");
        } else {
            delete DssSavers.sumWarnings.warning04[fund];
            input.closest('[component="Input"]').removeClass("bad");
        }

        if (valueNow === valuePrevious && (valueNow && valuePrevious)) {
            input.closest('[component="Input"]').removeClass("bad alert");
        }

        this.badValuesAlert(section, popup);
    },

    checkAllContracts(section, popup = true) {
        let sum = 0;

        let inputs = section.find('input[name="value05"], input[name="value06"], input[name="value07"],input[name="value04"]');

        section.find('input[name="value05"], input[name="value06"], input[name="value07"]').each(function () {
            let input = $(this);
            let value = DssSavers.sanitizedValue(input.val());

            if (!isNaN(value)) {
                sum += value;
            }
        });

        let value01 = section.find('input[name="value04"]');
        let equal = DssSavers.sanitizedValue(value01.val());
        let fund = section.data("fund");
        const isInvalid = (sum !== equal && (equal || equal === 0));

        if (isInvalid || sum === 0) {
            DssSavers.sumWarnings.warning03[fund] = {
                value1: section.find('input[name="value05').val(),
                value2: section.find('input[name="value06"]').val(),
                value3: section.find('input[name="value07"]').val(),
                sum: section.find('input[name="value04"]').val(),
                company: fund
            };
        } else {
            delete DssSavers.sumWarnings.warning03[fund];
        }

        this.badValuesAlert(section, popup);

        if (isInvalid || sum === 0) {
            inputs.closest('[component="Input"]').addClass("bad");
        } else {
            inputs.closest('[component="Input"]').removeClass("bad");
        }
    },

    badValuesAlert(section, popup = true) {
        if (!popup || this.el.hasClass("disabled")) {
            return;
        }

        let alert = $(".badValuesAlert");

        if (!this.isWarningEmpty('warning01') ||
            !this.isWarningEmpty('warning02') ||
            !this.isWarningEmpty('warning03') ||
            !this.isWarningEmpty('warning04')) {
            this.submitButton.prop("disabled", true);

            alert.addClass("visible");
        } else {
            this.submitButton.prop("disabled", false);

            alert.removeClass("visible");
            return;
        }

        if (section.find(".bad").length !== 0) {
            //return
        }

        const templates = alert.find(".templates");
        const info = alert.find(".info");

        info.html("");

        setTimeout(() => {
            $.each(DssSavers.sumWarnings, function (key, data) {
                if (Object.entries(data).length === 0) {
                    return;
                }

                $.each(Object.values(data), function (dss, alert) {
                    if (Object.entries(alert).length === 0) {
                        return;
                    }

                    if (info.find('[company="' + alert.company + '"][alert="' + key + '"]').length > 0) {
                        return;
                    }

                    let article = templates.find("." + key).clone();

                    article.find(".company").text(COMPANIES[alert.company][0]["name"]);
                    article.find(".value01").text(alert.value1);
                    article.find(".value02").text(alert.value2);
                    article.find(".difference").text(alert.difference);
                    if (alert.value3) {
                        article.find(".value03").text(alert.value3);
                    }
                    article.find(".sum").text(alert.sum);

                    article.addClass("visible");
                    article.attr("company", alert.company).attr("alert", key);

                    info.append(article);
                });
            });
        }, 500);
    },

    isWarningEmpty(warningKey) {
        return DssSavers.sumWarnings[warningKey].every(function(element) {
            return Object.keys(element).length === 0;
        });
    },

    sanitizedValue(value) {
        value = value.replaceAll(/\s/g, "");
        value = value.replaceAll(/€/g, "");

        return parseFloat(value);
    },

    download(fileUrl) {
        let req = new XMLHttpRequest();
        req.open("GET", fileUrl, true);
        req.responseType = "blob";
        //req.setRequestHeader('my-custom-header', 'custom-value'); // adding some headers (if needed)

        req.onload = function (event) {
            let blob = req.response;
            let fileName = req.getResponseHeader("fileName");
            let contentType = req.getResponseHeader("content-type");

            // IE/EDGE seems not returning some response header
            if (req.getResponseHeader("content-disposition")) {
                var contentDisposition = req.getResponseHeader("content-disposition");
                fileName = contentDisposition.substring(contentDisposition.indexOf("=") + 1);
            } else {
                fileName = "unnamed." + contentType.substring(contentType.indexOf("/") + 1);
            }

            if (window.navigator.msSaveOrOpenBlob) {
                // Internet Explorer
                window.navigator.msSaveOrOpenBlob(new Blob([blob], {type: contentType}), fileName);
            } else {
                let el = document.getElementById("target");
                el.href = window.URL.createObjectURL(blob);
                el.download = fileName;
                el.click();
            }
        };
        req.send();
    }
}
export default DssSavers;